import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  Checkbox,
  Link,
} from "@mui/material";
import "./styles.css";
import { COLORS } from "../../../utils/colors";

export default function ConsentModal({
  event,
  open,
  onConfirm,
  onCancel,
  consentType,
  consentText,
}) {
  const [isChecked, setIsChecked] = useState(false);

  // Reset checkbox state whenever modal opens or consent type changes
  useEffect(() => {
    if (open) {
      setIsChecked(false);
    }
  }, [open, consentType]);

  const handleConfirm = () => {
    if (isChecked) {
      onConfirm();
    }
  };

  const handleCancel = () => {
    setIsChecked(false);
    onCancel();
  };

  // Function to render text with clickable Privacy Policy link
  const renderConsentText = (text) => {
    if (!text) return null;

    // Check if text contains "Privacy Policy" and we have a terms URL
    if (
      text.includes("Privacy Policy") &&
      event?.loginSettings?.termsOfUseURL
    ) {
      const parts = text.split("Privacy Policy");
      return (
        <span>
          {parts[0]}
          <Link
            href={event.loginSettings.termsOfUseURL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#1976d2",
              textDecoration: "underline",
            }}
          >
            Privacy Policy
          </Link>
          {parts[1]}
        </span>
      );
    }

    return text;
  };

  return (
    <Dialog
      maxWidth="sm"
      open={open}
      aria-labelledby="consent-dialog-title"
      aria-describedby="consent-dialog-description"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <Paper style={{ backgroundColor: "white", padding: "20px" }}>
        <DialogTitle
          id="consent-dialog-title"
          style={{
            textAlign: "center",
            color: "#333",
            fontWeight: "bold",
            fontSize: "1.3rem",
            paddingBottom: "16px",
          }}
        >
          {consentType} Consent Required
        </DialogTitle>
        <DialogContent style={{ textAlign: "left", padding: "0 20px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "24px",
            }}
            onClick={(e) => setIsChecked(!isChecked)}
          >
            <Checkbox
              checked={isChecked}
              sx={{
                color: COLORS.primary,
                "&.Mui-checked": { color: COLORS.primary },
                alignSelf: "flex-start",
                marginRight: "8px",
              }}
            />
            <Typography
              variant="body2"
              style={{
                color: "#333",
                fontSize: "0.9rem",
                lineHeight: "1.4",
              }}
            >
              {renderConsentText(consentText)}
            </Typography>
          </div>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
            gap: "12px",
            padding: "0 20px 20px",
          }}
        >
          <Button
            onClick={handleCancel}
            variant="outlined"
            style={{
              color: COLORS.primary,
              borderColor: COLORS.primary,
              textTransform: "none",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            disabled={!isChecked}
            style={{
              color: COLORS.textHeader,
              backgroundColor: isChecked
                ? event && event.brandingBackgroundColor
                  ? event.brandingBackgroundColor
                  : COLORS.primary
                : "#ccc",
              textTransform: "none",
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Paper>
    </Dialog>
  );
}
